import React, { useEffect, useRef } from "react";
import { renderIconPreview } from "./iconUtils";

interface IconPreviewCanvasProps {
  iconKey: string;
  size?: number;
  className?: string;
}

export const IconPreviewCanvas: React.FC<IconPreviewCanvasProps> = ({
  iconKey,
  size = 22,
  className = "flex-shrink-0",
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && iconKey) {
      renderIconPreview(canvasRef.current, iconKey, size);
    }
  }, [iconKey, size]);

  if (!iconKey) return null;
  return <canvas ref={canvasRef} width={size} height={size} className={className} />;
};

export default IconPreviewCanvas;
